import { render, staticRenderFns } from "./MenuEmanifiestoDA.vue?vue&type=template&id=2a5c59cc&scoped=true&"
import script from "./MenuEmanifiestoDA.vue?vue&type=script&lang=js&"
export * from "./MenuEmanifiestoDA.vue?vue&type=script&lang=js&"
import style0 from "./MenuEmanifiestoDA.vue?vue&type=style&index=0&id=2a5c59cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5c59cc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VDivider,VIcon,VList,VMenu,VSpacer})
